import { Grid, Paper, Stack, useTheme } from '@mui/material';
import type { HomePageCurrentBillingCycleInformation } from '@weft/api-definition';
import { formatPrice } from '@weft/services';
import { DEFAULT_CURRENCY } from '@weft/types';
import { HomePageEndOfMonthHeader } from './HomePageEndOfMonthHeader';
import { HomePageEndOfMonthStatCard } from './HomePageEndOfMonthStatCard';

type HomePageEndOfMonthClosureSectionProps = {
  billingCycleInformation: HomePageCurrentBillingCycleInformation;
};

export const HomePageEndOfMonthClosureSection: React.FC<HomePageEndOfMonthClosureSectionProps> = 
({ billingCycleInformation: { overchargesSum, totalInvoicesCount, totalInvoicesSum, overageInvoicesCount } }) => {
  const vyTheme = useTheme();
  const isEmptyInvoices = totalInvoicesCount === 0;
  const isOverageEmptyState = overageInvoicesCount === 0;

  return (
    <Paper
      variant='outlined' 
      sx={(theme) => ({
        boxShadow: theme.shadows[1],
        padding: 3,
      })}
    >
      <Stack gap={2}>
        <HomePageEndOfMonthHeader />
        <Grid
          spacing={2}
          container
        >
          <Grid
            xs={6}
            item
          >
            <HomePageEndOfMonthStatCard 
              label={isOverageEmptyState ? 'No overages' : 'Invoices to review'}
              subLabel={isOverageEmptyState ? 'Invoices for review will appear here' : String(overageInvoicesCount)}
              chipLabel={`Overages: ${formatPrice(overchargesSum, DEFAULT_CURRENCY, 0, 0)}`}
              emptyState={isOverageEmptyState}
              logoColor={vyTheme.palette.error.main}
              chipColor='error'
            />
          </Grid>
          <Grid
            xs={6}
            item
          >
            <HomePageEndOfMonthStatCard 
              label={isEmptyInvoices ? 'No invoices' : 'Total Invoices'}
              subLabel={isEmptyInvoices ? 'Your invoice will appear here' : String(totalInvoicesCount)}
              chipLabel={`Total: ${formatPrice(totalInvoicesSum, DEFAULT_CURRENCY, 0, 0)}`}
              logoColor={vyTheme.palette.secondary.main}
              emptyState={isEmptyInvoices}
              chipColor='secondary'
            />
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  );
};